/** Baselines Types */
export const GET_BASELINES = 'GET_BASELINES';
export const GET_BASELINES_SUCCESS = 'GET_BASELINES_SUCCESS';
export const CREATE_BASELINE = 'CREATE_BASELINE';
export const CREATE_BASELINE_SESSION = 'CREATE_BASELINE_SESSION';
export const EDIT_BASELINE = 'EDIT_BASELINE';
export const EDIT_BASELINE_SESSION = 'EDIT_BASELINE_SESSION';
export const DELETE_BASELINE_SESSION = 'DELETE_BASELINE_SESSION';

/** End */
